export default __webpack_public_path__ + "static/media/img-0320-madagascar-half-face.fcb3a967.png";